var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-section"},_vm._l((_vm.sidenavigation),function(item){return _c('NavigationItem',{key:item['@id'],attrs:{"item":item,"isHomePage":_vm.isHomePage}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }